import { useMemo } from 'react';

import { Box, Divider, Stack, Theme, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { formatDistanceToNow } from "date-fns";
import { useAutomaticDiscountList } from '../shared/hooks/useAutomaticDiscountList';
import useLoggedInCustomer from '../shared/hooks/useLoggedInCustomer';

type Props = {
    banners?: { text: string }[]
}

export const bannerHeight = (isBigDefautDiscount: boolean, wholesale: boolean) => wholesale ? 0 : (isBigDefautDiscount ? 40 : 40);

const useStyles = (theme: Theme) => ({
    container: {
        // position: 'absolute',
        // zIndex: 99,
        // top: 0,
        // left: 0,
        fontWeight: theme.typography.fontWeightBold,
        // color: theme.palette.warning.contrastText,
        backgroundColor: theme.palette.warning.dark,
        py: { xs: 0.4, sm: 0.5, md: 0.6 },
        width: '100%',
    },
    content: {
        textAlign: 'center',
        fontSize: {
            xs: '0.8rem',
            sm: 'initial',
            md: 'initial'
        }
    },
    divider: {
        borderColor: theme.palette.text.primary,
        height: '20px'
    }
})

export const SiteBanner = ({ banners }: Props) => {
    const theme = useTheme();
    const styles = useStyles(theme);

    const { defaultDiscount } = useAutomaticDiscountList();

    const loggedInCustomer = useLoggedInCustomer();

    const filteredBanners = useMemo(() => {
        if (!defaultDiscount || !banners) return banners || [];

        if (defaultDiscount) return [];

        return banners.filter(e => e.text !== defaultDiscount.title);
    }, []);

    if ((!filteredBanners || filteredBanners.length === 0) && (!defaultDiscount)) return <></>;

    // console.log('heree', isBigDefaultDiscount, defaultDiscount)

    // if defaultDiscount.endsAt < 7 days, show ends in
    if (defaultDiscount && defaultDiscount.endsAt) {
        const nowDate = new Date();
        // Align to UTC hour
        const currentDateUtc = new Date(
            Date.UTC(
                nowDate.getUTCFullYear(),
                nowDate.getUTCMonth(),
                nowDate.getUTCDate(),
                nowDate.getUTCHours(),
                0, 0, 0
            )
        );

        const endsAtDate = new Date(defaultDiscount.endsAt);
        const diffInMs = endsAtDate.getTime() - currentDateUtc.getTime();
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

        if (diffInDays > 7) {
            // don't show ends in
            defaultDiscount.endsAt = null;
        }
    }

    const discountEndsAt = defaultDiscount && defaultDiscount.endsAt ? formatDistanceToNow(new Date(defaultDiscount.endsAt)) : null;

    return (
        <Box sx={{ ...styles.container, visibility: loggedInCustomer.wholesale ? 'hidden' : undefined, height: loggedInCustomer.wholesale ? { xs: '10px', sm: '10px', md: '15px' } : undefined }}>
            <Stack direction={"row"}
                divider={<Divider orientation="vertical" sx={styles.divider} />}
                spacing={{ xs: 1, sm: 1, md: 2 }} alignItems='center' justifyContent='center'>


                {filteredBanners.map((banner, index) => (
                    <Box sx={{ ...styles.content, display: { xs: index > 1 ? 'none' : 'inherit', sm: 'inherit' } }} key={index}>
                        <Typography variant="h5" sx={[{
                            fontSize: {
                                sm: 'initial'
                            }
                        }, filteredBanners.length > 1 ? {
                            fontSize: {
                                xs: '0.8rem'
                            }
                        } : {
                            fontSize: {
                                xs: 'initial'
                            }
                        }]}>{banner.text}</Typography>
                    </Box>
                ))}
                {defaultDiscount && (
                    <Box sx={{ ...styles.content, display: { xs: 'inherit', sm: 'inherit', md: 'inherit' } }}>
                        <Stack direction="row" spacing={1} alignItems='center'>
                            {/* <Celebration /> */}
                            <Typography variant="h4" sx={[{
                                fontSize: {
                                    sm: 'initial'
                                }
                            }, filteredBanners.length > 1 ? {
                                fontSize: {
                                    xs: '0.8rem'
                                }
                            } : {
                                fontSize: {
                                    xs: 'initial'
                                }
                            }]}> {defaultDiscount.title}{discountEndsAt ? ` - ends in ${discountEndsAt}` : ''}</Typography>
                            {/* <Celebration /> */}
                        </Stack>

                    </Box>
                )}




            </Stack>
        </Box>
    );
}